import { render } from "./SchoolTemplate.vue?vue&type=template&id=0173e99f&scoped=true"
import script from "./SchoolTemplate.vue?vue&type=script&lang=js"
export * from "./SchoolTemplate.vue?vue&type=script&lang=js"

import "./SchoolTemplate.vue?vue&type=style&index=0&id=0173e99f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0173e99f"]])

export default __exports__